// Intermarché kiosks : their label contains this prefix (same rule as the back-end check)
const GMS_ITM_LABEL = 'GMS_ITM_'
// PDV01234, or PDV01234_1 when there are several kiosks in the store (same formats as the Intermarché exports)
const PDV_FORMAT = /^PDV[0-9]{5}(_[0-9])?$/

class KioskPdvHelper {
	/**
	 * @param { string } kioskLabel kiosk label
	 * @return { boolean } true if the kiosk is an Intermarché one
	 */
	static isGmsItm(kioskLabel) {
		return !!kioskLabel && kioskLabel.includes(GMS_ITM_LABEL)
	}

	/**
	 * @param { string } code customer kiosk code entered
	 * @param { string } kioskLabel kiosk label entered
	 * @return { boolean } false if the kiosk is an Intermarché one and its customer kiosk code is entered but is not a PDV number
	 * (a kiosk can have no code)
	 */
	static isPdvValid(code, kioskLabel) {
		if (!KioskPdvHelper.isGmsItm(kioskLabel)) return true
		const pdv = KioskPdvHelper.toPdv(code)
		return pdv === '' || PDV_FORMAT.test(pdv)
	}

	/**
	 * Kiosk in production : the code is checked only if it changes, or if the kiosk becomes an Intermarché one
	 * (the existing kiosks without code can still be updated)
	 * @param { string } code customer kiosk code entered
	 * @param { string } kioskLabel kiosk label entered
	 * @param { string } savedCode customer kiosk code saved
	 * @param { string } savedKioskLabel kiosk label saved
	 * @return { boolean } false if the code is refused
	 */
	static isPdvValidOnUpdate(code, kioskLabel, savedCode, savedKioskLabel) {
		const unchanged = KioskPdvHelper.toPdv(code) === KioskPdvHelper.toPdv(savedCode) && KioskPdvHelper.isGmsItm(savedKioskLabel)
		return unchanged || KioskPdvHelper.isPdvValid(code, kioskLabel)
	}

	/**
	 * @param { string } code customer kiosk code
	 * @return { string } the code trimmed and in upper case
	 */
	static toPdv(code) {
		return (code || '').trim().toUpperCase()
	}
}

export default KioskPdvHelper
